
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"58","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.625 1.813H43.5a3.625 3.625 0 013.625 3.625v48.937A3.625 3.625 0 0143.5 58H3.625A3.625 3.625 0 010 54.375V5.437a3.625 3.625 0 013.625-3.625z","fill":"#D0D5D9"}}),_c('path',{attrs:{"d":"M3.625 42.438v-37H43.5v48.937H15.562L3.625 42.438z","fill":"#EFEFEF"}}),_c('path',{attrs:{"d":"M15.562 42.438v11.937L3.625 42.438h11.937zM14.5 7.25V0h18.125v7.25A3.625 3.625 0 0129 10.875H18.125A3.625 3.625 0 0114.5 7.25z","fill":"#52B788"}}),_c('path',{attrs:{"d":"M19.938 14.5h14.5a1.813 1.813 0 010 3.625h-14.5a1.813 1.813 0 010-3.625zM10.875 14.5H14.5v3.625h-3.625V14.5zM10.875 21.75H14.5v3.625h-3.625V21.75zM10.875 29H14.5v3.625h-3.625V29zM10.875 36.25H14.5v3.625h-3.625V36.25zM19.938 21.75h10.875a1.813 1.813 0 010 3.625H19.938a1.813 1.813 0 010-3.625zM19.938 29h3.625a1.813 1.813 0 010 3.625h-3.625a1.813 1.813 0 010-3.625z","fill":"#77959E"}})])
          )
        }
      }
    